const phase9 = [
	{
		path: '/agency/dashboard',
		name: 'agency-dashboard',
		component: () => import('@/views/agency/dashboard/Index.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
	{
		path: '/agency/reviews/list',
		name: 'agency-reviews-list',
		component: () => import('@/views/agency/reviews/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
	{
		path: '/agency/campaign-orders/list',
		name: 'agency-campaign-orders-list',
		component: () => import('@/views/agency/campaign-orders/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
	{
		path: '/agency/campaign-orders/:id',
		name: 'agency-campaign-orders-view',
		component: () => import('@/views/agency/campaign-orders/view.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
	{
		path: '/agency/campaign-orders/:id/results',
		name: 'agency-campaign-orders-results',
		component: () => import('@/views/agency/campaign-orders/results.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
	{
		path: '/agency/proposals/list',
		name: 'agency-proposals-list',
		component: () => import('@/views/agency/proposals/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
	{
		path: '/agency/reports/list',
		name: 'agency-reports-list',
		component: () => import('@/views/agency/reports/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
	{
		path: '/agency/reports/categories',
		name: 'agency-reports-categories',
		component: () => import('@/views/agency/reports/categories.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
	{
		path: '/agency/walls/list',
		name: 'agency-walls-list',
		component: () => import('@/views/agency/walls/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-release',
		},
	},
	{
		path: '/agency/press-release/campaigns',
		name: 'agency-pr-campaigns-list',
		component: () => import('@/views/agency/press-release/campaigns/list.vue'),
		meta: { layout: 'content', module: 'MGAG,press-release' },
	},
	{
		path: '/agency/press-release/campaigns/collective-new',
		name: 'agency-pr-campaigns-collective-new',
		component: () => import('@/views/agency/press-release/campaigns/collective-new.vue'),
		meta: { layout: 'content', module: 'MGAG,press-release' },
	},
	{
		path: '/agency/press-release/campaigns/import',
		name: 'agency-pr-campaigns-import',
		component: () => import('@/views/agency/press-release/campaigns/import.vue'),
		meta: { layout: 'content', module: 'MGAG,press-release' },
	},
	{
		path: '/agency/press-release/calendar',
		name: 'agency-pr-campaigns-calendar',
		component: () => import('@/views/agency/press-release/campaigns/calendar.vue'),
		meta: { layout: 'content', module: 'MGAG,press-release' },
	},
	{
		path: '/agency/press-release/campaigns/:id',
		name: 'agency-pr-campaigns-detail',
		component: () => import('@/views/agency/press-release/campaigns/detail.vue'),
		meta: { layout: 'content', module: 'MGAG,press-release' },
	},
	{
		path: '/agency/press-release/unsubscribe-reasons',
		name: 'agency-pr-unsubscribe-reasons',
		component: () => import('@/views/agency/press-release/unsubscribe-reasons/list.vue'),
		meta: { layout: 'content', module: 'MGAG,press-release' },
	},
	{
		path: '/agency/press-release/funnels',
		name: 'agency-pr-funnels-list',
		component: () => import('@/views/agency/press-release/funnels/list.vue'),
		meta: { layout: 'content', module: 'MGAG,press-release' },
	},
	{
		path: '/agency/press-release/funnels/:id',
		name: 'agency-pr-funnels-detail',
		component: () => import('@/views/agency/press-release/funnels/detail.vue'),
		meta: { layout: 'content', module: 'MGAG,press-release' },
	},
	{
		path: '/agency/briefings',
		name: 'agency-briefings-list',
		component: () => import('@/views/agency/briefings/list.vue'),
		meta: { layout: 'content', module: 'MGAG,press-release' },
	},
	{
		path: '/agency/briefings/:id',
		name: 'agency-briefings-detail',
		component: () => import('@/views/agency/briefings/detail.vue'),
		meta: { layout: 'content', module: 'MGAG,press-release' },
	},
]

export default phase9
